import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'

import { GTM_ID } from '@src/constants'
import { useGetMyAccount } from '@queries/Account'
import { useGetTeamSubscription } from '@queries/Billing'

const use3rdParties = () => {
  const { data: user } = useGetMyAccount()
  const { data: subscription } = useGetTeamSubscription({ enabled: !!user })

  useEffect(() => {
    if (GTM_ID) {
      TagManager.initialize({ gtmId: GTM_ID })
    }
  }, [])

  useEffect(() => {
    if (user?.username && user?.team && subscription) {
      Sentry.setUser({ id: user.id, email: user.email, name: user.team.name, username: user.team.name })

      if (GTM_ID) {
        TagManager.dataLayer({
          dataLayer: {
            user_id: user.id,
          },
        })
      }

      posthog.identify(user.id.toString(), {
        email: user.email,
        name: user.name,
        role: user.role,
        team_name: user.team?.name,
        team_id: user.team?.id,
        plan: subscription.plan,
      })

      if (user.team?.id) {
        posthog.group('company', user.team.id.toString(), {
          name: user.team.name,
          plan: subscription.plan,
          is_trial: subscription.is_trial,
        })
      }

      if (window.Intercom) {
        window.Intercom('update', {
          name: user.name,
          email: user.email,
          user_id: user.id.toString(),
          Role: user.role,
          company: {
            name: user.team?.name,
            company_id: user.team?.id,
            plan: subscription.plan,
            'Is Trial': subscription.is_trial,
            'Ends At': subscription.ends_at,
          },
          hide_default_launcher: !user.vendor_id,
          custom_launcher_selector: !user.vendor_id ? '#intercom-chat' : undefined,
          alignment: user.vendor_id ? 'left' : 'right',
        })
      }
    }
  }, [user, subscription])

  useEffect(() => {
    window.Intercom?.('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'hexn2c71',
    })
  }, [])
}

export default use3rdParties
